var map = {
	"./air-nga-en/assets/win-data-icon.png": 81631,
	"./ais-tai-en/assets/win-data-icon.png": 62574,
	"./ais-tai-tha/assets/win-data-icon.png": 6938,
	"./demo-arabic/assets/win-data-icon.png": 25554,
	"./demo-et-en/assets/win-data-icon.png": 72675,
	"./demo-romanian/assets/win-data-icon.png": 85573,
	"./demo-um-en/assets/win-data-icon.png": 45554,
	"./dtac-tai-en/assets/win-data-icon.png": 2853,
	"./dtac-tai-tha/assets/win-data-icon.png": 43607,
	"./ethiotel-et-amh/assets/win-data-icon.png": 3073,
	"./ethiotel-et-en/assets/win-data-icon.png": 93780,
	"./mtn-cg-fr/assets/win-data-icon.png": 93097,
	"./mtn-ci-fr/assets/win-data-icon.png": 52935,
	"./mtn-cmr-fr/assets/win-data-icon.png": 87563,
	"./mtn-gha-en/assets/win-data-icon.png": 31676,
	"./mtn-nga-en/assets/win-data-icon.png": 24976,
	"./mtn-zam-en/assets/win-data-icon.png": 85490,
	"./saf-ke-en/assets/win-data-icon.png": 47099,
	"./saudi-uae-en/assets/win-data-icon.png": 23330,
	"./tlk-za-en/assets/win-data-icon.png": 26015,
	"./vc-za-en/assets/win-data-icon.png": 85611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70481;